import HeroComponent from '../components/hero';

export default class HomeController {

  constructor(options) {
    this.options = options;
    console.log('GENERAL CONTROLLER');

    this.general_comingsoon = new HeroComponent({
      elem      :'section.general__comingsoon',
    });

  }

  handleResize() {
  }

  handleScroll() {

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/GeneralController.js